import SearchContext from 'contexts/SearchContext';
import { Zemljevid } from 'kzv-icons';
import React, { useContext } from 'react';
import { Grid } from 'react-feather';
import { Mixpanel } from 'utils/Mixpanel';

import Button from '../buttons/Button';
import { setMapView } from 'contexts/SearchActions';

function MapViewToggle({ variant = 'outlined', color = 'secondary' }) {
    const { state, dispatch } = useContext(SearchContext);

    const handleClick = () => {
        Mixpanel.track('Search view toggle', {
            view: state.mapView ? 'list' : 'map'
        });
        setMapView(dispatch, !state.mapView);
    };

    return (
        <div className="inline-block pointer-events-auto">
            {!state.mapView && (
                <Button
                    onClick={handleClick}
                    variant={variant}
                    color={color}
                    startIcon={<Zemljevid style={{ strokeWidth: 1, fontSize: '1.5rem' }} />}
                >
                    Zemljevid
                </Button>
            )}
            {state.mapView && (
                <Button
                    onClick={handleClick}
                    variant={variant}
                    color={color}
                    startIcon={<Grid style={{ fontSize: '1.5rem' }} />}
                >
                    Seznam
                </Button>
            )}
        </div>
    );
}

export default MapViewToggle;
